export const typeTranslate: { [key: string]: string } = {
  none: 'Provas sem vídeo e com auditoria',
  fiscal: 'Prova com Fiscal',
  photo: 'Prova com foto',
  video: 'Provas com vídeo (recomendada)',
};
